import { render, staticRenderFns } from "./Heatmap.vue?vue&type=template&id=40521604&scoped=true&lang=pug&"
import script from "./Heatmap.vue?vue&type=script&lang=js&"
export * from "./Heatmap.vue?vue&type=script&lang=js&"
import style0 from "./Heatmap.vue?vue&type=style&index=0&id=40521604&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40521604",
  null
  
)

export default component.exports